export default "__VITE_ASSET__Dhq_9ABT__"